import lodashCapitalize from 'lodash.capitalize';

const capitalize = word => lodashCapitalize(word);

export { capitalize };
